// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navtree-root {
  position: sticky;
  top: 0px;
  width: fit-content;
  padding: 12px;
  height: fit-content;
}
.nav-context {
  position: relative;
  display: flex;
  flex-wrap: wrap-reverse;
  flex-direction: row-reverse;
  align-items: flex-end;
}
.nav-content {
  min-height: 200px;
}
.nav-content-root {
  max-width: 900px;
}
.navtree-section {
  padding: 10px 15px;
  cursor: pointer;
  margin: 3px 0px;
}
.navtree-section.l1 {
  background: whitesmoke;
  color: #3e3e3e;
}
.navtree-section.l1 > .navtree-label {
  text-transform: uppercase;
  font-weight: 500;
  padding-bottom: 4px;
}
.navtree-section.l1 .l2:hover {
  color: black;
}
.navtree-section.l1.select {
  background: black;
  color: #ababab;
}
.navtree-section.l1.select > .navtree-label {
  color: white;
}
.navtree-section.l1.select .l2:hover {
  color: white;
}
.navtree-section.l1.select .l2:hover.select {
  color: black;
}
.navtree-section.l2.select {
  background: #00ffe5;
  color: black;
}
.navtree-section.l2.yellow.select {
  background: yellow;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./docs-site/NavBar.less"],"names":[],"mappings":"AACA;EACC,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAAD;AAGA;EACC,kBAAA;EACG,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;AADJ;AAIA;EACC,iBAAA;AAFD;AAKA;EACC,gBAAA;AAHD;AAcA;EACC,kBAAA;EACA,eAAA;EACG,eAAA;AAZJ;AAcC;EACC,sBAAA;EACA,cAAA;AAZF;AAUC;EAIE,yBAAA;EACA,gBAAA;EACA,mBAAA;AAXH;AAKC;EASE,YAAA;AAXH;AAeC;EACC,iBAAA;EACA,cAAA;AAbF;AAWC;EAIE,YAAA;AAZH;AAQC;EASE,YAAA;AAdH;AAeG;EACC,YAAA;AAbJ;AAkBC;EACC,mBAAA;EAEA,YAAA;AAjBF;AAoBC;EACC,kBAAA;EAEA,YAAA;AAnBF","sourcesContent":["\n.navtree-root{\n\tposition: sticky;\n\ttop: 0px;\n\twidth: fit-content;\n\tpadding: 12px;\n\theight: fit-content;\n}\n\n.nav-context{\n\tposition: relative;\n    display: flex;\n    flex-wrap: wrap-reverse;\n    flex-direction: row-reverse;\n    align-items: flex-end;\n}\n\n.nav-content{\n\tmin-height: 200px;\n}\n\n.nav-content-root{\n\tmax-width: 900px;\n}\n\n\n\n\n\n\n\n\n\n.navtree-section{\n\tpadding: 10px 15px;\n\tcursor: pointer;\n    margin: 3px 0px;\n\t\n\t&.l1{\n\t\tbackground: whitesmoke;\n\t\tcolor: rgb(62, 62, 62);\n\t\t>.navtree-label{\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: 500;\n\t\t\tpadding-bottom: 4px;\n\t\t}\n\t\t.l2:hover{\n\t\t\tcolor: black;\n\t\t}\n\t}\n\n\t&.l1.select{\n\t\tbackground: black;\n\t\tcolor: rgb(171, 171, 171);\n\t\t>.navtree-label{\n\t\t\tcolor: white;\n\t\t\t\n\t\t}\n\n\t\t.l2:hover{\n\t\t\tcolor: white;\n\t\t\t&.select{\n\t\t\t\tcolor: black;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.l2.select{\n\t\tbackground: rgb(0, 255, 229); //linear-gradient(45deg, rgb(74, 255, 237), #00d9ff);\n\t\t// box-shadow: 0px 0px 6px #00fff07d;\n\t\tcolor: black;\n\t}\n\n\t&.l2.yellow.select{\n\t\tbackground: yellow;//(0, 255, 229); //linear-gradient(45deg, rgb(74, 255, 237), #00d9ff);\n\t\t// box-shadow: 0px 0px 6px #00fff07d;\n\t\tcolor: black;\n\t}\n\t\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
